import {chevronDownCircleSvg as Icon__small__chevronDownCircleSvg} from '../Icon__small/Icon__small--chevronDownCircle.js';

export var chevronDownCircle = {
  name: 'chevronDownCircle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__chevronDownCircleSvg,
};
